import type { IconData } from '@stacksjs/iconify-core'

export const printer: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M16 14h1a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h1V9h12zM4 4V0h12v4h1a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3h-1v4H4v-4H3a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3zm2 14h8v-7H6zM6 4h8V2H6z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default printer
